/**
 * Professional Mobile Navigation
 * RubberMatting-Direct.co.uk
 */
(function() {
  'use strict';

  function init() {
    const mobileMenu = document.getElementById('pro-mobile-menu');
    if (!mobileMenu) return;

    // Get the existing mobile toggle button
    const mobileToggle = document.querySelector('.header__mobile-nav-toggle');
    
    // Override the existing toggle to open our menu
    if (mobileToggle) {
      mobileToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openMenu();
      });
    }

    // Close buttons
    const closeButtons = mobileMenu.querySelectorAll('[data-action="close-mobile-menu"]');
    closeButtons.forEach(btn => {
      btn.addEventListener('click', closeMenu);
    });

    // Accordion functionality
    const accordions = mobileMenu.querySelectorAll('.pro-mobile__accordion');
    accordions.forEach(accordion => {
      accordion.addEventListener('click', () => {
        const isExpanded = accordion.getAttribute('aria-expanded') === 'true';
        
        // Close all others
        accordions.forEach(other => {
          if (other !== accordion) {
            other.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Toggle current
        accordion.setAttribute('aria-expanded', !isExpanded);
      });
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Prevent body scroll when open
    function openMenu() {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Focus first link
      setTimeout(() => {
        const firstLink = mobileMenu.querySelector('a, button');
        if (firstLink) firstLink.focus();
      }, 300);
    }

    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // Reset accordions
      accordions.forEach(a => a.setAttribute('aria-expanded', 'false'));
      
      // Return focus to toggle
      if (mobileToggle) mobileToggle.focus();
    }

    // Highlight current page
    const currentPath = window.location.pathname;
    const links = mobileMenu.querySelectorAll('a[href]');
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href === currentPath || (currentPath.startsWith(href) && href !== '/' && href.length > 1)) {
        link.classList.add('is-current');
        link.style.fontWeight = '700';
        link.style.color = '#054c9c';
        
        // Expand parent accordion
        const accordion = link.closest('.pro-mobile__accordion-content');
        if (accordion) {
          const trigger = accordion.previousElementSibling;
          if (trigger && trigger.classList.contains('pro-mobile__accordion')) {
            trigger.setAttribute('aria-expanded', 'true');
          }
        }
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
